// React
import React from "react";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const AnalyticsProvider = ({ children }) => {
  // Framework
  const { analytics } = usePortal();
  // Init
  useStackDependency(analytics);
  // Render
  return <>{children}</>;
};

export { AnalyticsProvider };
